<template lang="pug">
  header#header.pb-1
    b-container(fluid)
      b-row.form-box.mx-auto(:no-gutters="true")
        b-col.mt-3.ml-3
          h3.mb-2.text-muted
            img.mr-3.logo_desknets(src="@/assets/images/logo_desknetsneo.png")
            | |
            img.ml-3.logo_chatluck(src="@/assets/images/logo_chatluck.png")
        b-col.mr-3.text-right.d-flex.align-items-center.justify-content-end
          p.mt-2.mb-0
            a.text-dark.mr-3(href="https://www.desknets.com/", target="_blank") desknet's NEO公式サイト
            | |
            a.text-dark.ml-3(href="https://www.chatluck.com/", target="_blank") ChatLuck公式サイト
    b-navbar.header_box.mb-2(variant="dark", type="dark")
      .item_box.mx-auto
        b-navbar-nav.ml-3
          b-nav-item(:to="{name: 'Login'}")
            b-icon.mt-1.mr-3.next-icon(scale=1.4, icon="house")
            span.mt-1.float-right クラウド版サポートサイト
</template>

<script>
export default {
  name: "HeaderBeforeLogin"
}
</script>

<style scoped>
.logo_desknets {
  position: relative;
  width: 200px;
  bottom: 8px;
}
.logo_chatluck {
  position: relative;
  width: 200px;
  bottom: 5px;
}
.header_box {
  height: 50px;
  background-color: black !important;
}
.form-box {
  max-width: 1200px;
}
.item_box {
  width: 1200px;
}
</style>